export default {
      id: "icon-down-arrow-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#icon-down-arrow-icon",
      toString: function () {
        return this.url;
      }
    }